/** Тексты десктоп-раскладки (EN — источник ключей, RU и UK обязаны покрыть каждый). */
import type { MessageBundle } from "../../i18n";

export const desktopEn = {
  "desktop.heroes": "Heroes panel",
  "desktop.side": "Streak and sharing",
  "desktop.tasks": "Daily tasks",
  "desktop.season": "Season",
  "desktop.league": "League",
  "desktop.share": "Share",
  "desktop.login": "Telegram login",
  "desktop.loginHint": "Log in with Telegram to keep your progress on any device.",
} as const;

export type DesktopKey = keyof typeof desktopEn;

export const desktopRu: Record<DesktopKey, string> = {
  "desktop.heroes": "Панель героев",
  "desktop.side": "Серия и шаринг",
  "desktop.tasks": "Задания дня",
  "desktop.season": "Сезон",
  "desktop.league": "Лига",
  "desktop.share": "Поделиться",
  "desktop.login": "Вход через Telegram",
  "desktop.loginHint": "Войдите через Telegram, чтобы прогресс сохранялся на любом устройстве.",
};

export const desktopUk: Record<DesktopKey, string> = {
  "desktop.heroes": "Панель героїв",
  "desktop.side": "Серія і поширення",
  "desktop.tasks": "Завдання дня",
  "desktop.season": "Сезон",
  "desktop.league": "Ліга",
  "desktop.share": "Поділитися",
  "desktop.login": "Вхід через Telegram",
  "desktop.loginHint": "Увійдіть через Telegram, щоб прогрес зберігався на будь-якому пристрої.",
};

export const desktopMessages: MessageBundle<DesktopKey> = { en: desktopEn, ru: desktopRu, uk: desktopUk };
